import { EntityImageLookup } from "../loyaltyTypes";
import { CategoryType } from "../types";
import {
  resolveCategoryUuid,
  resolveItemUuid,
  resolveSubItemUuid,
} from "../cart/entityKeys";

export const buildEntityImageLookup = (
  categories: CategoryType[]
): EntityImageLookup => {
  if (!categories?.length) {
    return {};
  }

  const lookup: EntityImageLookup = {};

  for (const category of categories) {
    const firstCategoryItemImage = category.itemCategories
      ?.map((itemCategory) => itemCategory.item?.img_url)
      .find(Boolean);
    if (firstCategoryItemImage) {
      const categoryKey = resolveCategoryUuid(category);
      if (categoryKey) {
        lookup[categoryKey] = { itemImage: firstCategoryItemImage };
      }
    }

    for (const itemCategory of category.itemCategories ?? []) {
      const item = itemCategory.item;
      if (!item?.img_url || !item?.subItems?.length) {
        continue;
      }

      const itemKey = resolveItemUuid(item);
      if (itemKey) {
        lookup[itemKey] = { itemImage: item.img_url, itemId: item.id };
      }

      for (const subItem of item.subItems) {
        const entry = { itemImage: item.img_url, itemId: item.id };
        const subItemKey = resolveSubItemUuid(subItem);
        if (subItemKey) {
          lookup[subItemKey] = entry;
        }
        if (subItem.id !== undefined && subItem.id !== null) {
          lookup[String(subItem.id)] = entry;
        }
      }
    }
  }

  return lookup;
};
